// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { PageLayout } from "#/features/global-ui/page-layout"
import { Title } from "#/services/page-title/Title"
import { Paths } from "#/utils/Paths"
import { BookingFlow, useProgramAccess } from "@internal/telemedicine"
import { useFlags } from "launchdarkly-react-client-sdk"
import React from "react"
import { Redirect, useHistory, useLocation } from "react-router-dom"

// The raw `?program=` value, or null when absent. Not validated here — the backend decides whether
// a program exists and is bookable (see useProgramAccess).
function useProgramParam(): string | null {
  const { search } = useLocation()
  const raw = new URLSearchParams(search).get("program")
  return raw === null || raw === "" ? null : raw
}

export function TelemedicineBookingPage(): JSX.Element | null {
  const { telemedicineBookingFlow } = useFlags()
  const history = useHistory()
  const program = useProgramParam()
  const { data: access, isLoading } = useProgramAccess(program)

  if (!telemedicineBookingFlow) {
    return <Redirect to={Paths.HOME} />
  }

  // No program named → let the resolver decide.
  if (program === null) {
    return <Redirect to={Paths.TELEMEDICINE} />
  }

  if (isLoading || !access) {
    return null
  }

  // Uniform "denied" (no reason) → home: don't leak unknown-vs-off-limits, and don't reroute into
  // a different program. Access is stubbed to allow today (MEM-677); it's UX only — the BFF enforces.
  if (access.status === "denied") {
    return <Redirect to={Paths.HOME} />
  }

  return (
    <PageLayout variant="default">
      <Title title="Telemedicine Booking" />
      <BookingFlow
        program={access.program}
        onExit={() => history.push(Paths.HOME)}
        onReturnToProviderResults={() => history.push(Paths.PROVIDER_FINDER)}
      />
    </PageLayout>
  )
}
